import { render, staticRenderFns } from "./integral.vue?vue&type=template&id=1236df8d&scoped=true"
import script from "./integral.vue?vue&type=script&lang=js"
export * from "./integral.vue?vue&type=script&lang=js"
import style0 from "./integral.vue?vue&type=style&index=0&id=1236df8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1236df8d",
  null
  
)

export default component.exports